<div class="size-selector">
    <span class="size-label">{{ 'dashboard.visuals.addModal.selectSize' | translate }}</span>
    <div class="size-options">
        @for (sizeOption of sizeOptionsViewModel(); track sizeOption.size) {
            <button
                type="button"
                class="size-option"
                [class.selected]="currentSelectedSize() === sizeOption.size"
                (click)="selectSize(sizeOption.size, $event)"
            >
                <div class="size-visual-container">
                    <div class="size-visual" [style.width.px]="sizeOption.visualWidth" [style.height.px]="sizeOption.visualHeight"></div>
                </div>
                <div class="size-info">
                    <span class="size-name">{{ sizeOption.label | translate }}</span>
                    <span class="size-dimensions">{{ sizeOption.dimensions }}</span>
                </div>
            </button>
        }
    </div>
</div>
